import { Component, ViewChild, Output, Input, EventEmitter, forwardRef } from "@angular/core";
import { ReCaptchaComponent } from "angular2-recaptcha";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";


@Component({
    selector: 'asi-captcha',
    templateUrl: './asi-captcha.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AsiCaptchaComponent),
            multi: true
        }
    ]
})
export class AsiCaptchaComponent implements ControlValueAccessor {

    @Input('value') _value: boolean;
    @Input() langue: string = "fr";
    @Output() handleCorrectCaptcha = new EventEmitter<string>();
    @Output() captchaExpired = new EventEmitter<{}>();
    @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;
    @Output() onValueChange = new EventEmitter<boolean>();

    constructor() {
    }

    public captchaResponse(event: string): void {
        this.handleCorrectCaptcha.emit(event);
        this.value = true;
    }

    public captchaExpiration(event: {}) {
        this.captchaExpired.emit(event);
        this.value = false;
    }

    //Controle value accessor
    onChange: any = () => {
    };
    onTouched: any = () => {
    };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
        this.onValueChange.emit(this._value);
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    writeValue(value: any) {
        this._value = value;
    }


}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/asi-captcha/asi-captcha.component.ts